import React from "react";
import History from "@common/components/shared/History";

const CustomerHistory = ({ customerId }) => {
  return (
    <div className="mt-1_5 mr-0_5">
      <History customerId={customerId} />
    </div>
  );
};

export default CustomerHistory;